/** @format */

import React, { useState } from "react";
import { Provider } from "react-redux";
import store from "../../redux/store";
import { Route, Routes } from "react-router-dom";
import MainLayout from "./layout/MainLayout";
import NotFound from "../notfound/NotFound";
import BoshSahifa from "./pages/Dashboard/BoshSahifa";
import SuvomborlariSahifa from "./pages/suvomborlar/index";
import Aqllisuv from "./pages/aqllisuv/AqlliSuv";
import AmudaryoSahifa from "./pages/balans/amudaryo/AmudaryoSahifa";
import SirdaryoSahifa from "./pages/balans/sirdaryo/SirdaryoSahifa";
import ZarafshonSahifa from "./pages/balans/zarafshon/ZarafshonSahifa";
import SuvdanfoydalanishSahifa from "./pages/suvdanfoydalanish/index";
import AsosiymanbalarSahifa from "./pages/asosiymanbalar/AsosiyManbalar";
import KoicaHourly from "./pages/asosiymanbalar/KoicaHourly";
import RavotxojiSahifa from "./pages/ravotxoji/Ravotxoji";
import OqjarqizilqishloqSahifa from "./pages/oqjar/Oqjar";
import ReykauchqorgonSahifa from "./pages/reka02/Reka02";
import VegetatsiyaSahifa from "./pages/sugorish/vegetatsiya/VegetatsiyaSahifa";
import NovegetatsiyaSahifa from "./pages/sugorish/novegetatsiya/NovegetatsiyaSahifa";
import LimitSahifa from "./pages/limitlar/LimitSahifa";
import Sfr from "./pages/sfr/Sfr";
import Xisobot from "./pages/sfr/xisobot/Xisobot";
import SttGpsSahifa from "./pages/sttgps";

function Index(props) {
  const [date, setDate] = useState(new Date().toISOString().slice(0, 10));
  return (
    <Provider store={store}>
      <Routes>
        <Route element={<MainLayout date={date} setDate={setDate} />}>
          <Route index element={<BoshSahifa date={date} />} />
          <Route path='suvomborlari/*' element={<SuvomborlariSahifa />} />
          <Route path='aqllisuv/*' element={<Aqllisuv />} />
          <Route path='stt-gps' element={<SttGpsSahifa />} />
          <Route path='amudaryo' element={<AmudaryoSahifa />} />
          <Route path='sirdaryo' element={<SirdaryoSahifa />} />
          <Route path='zarafshon' element={<ZarafshonSahifa />} />
          <Route
            path='suvdanfoydalanish/*'
            element={<SuvdanfoydalanishSahifa />}
          />
          <Route path='asosiymanbalar/*' element={<AsosiymanbalarSahifa />} />
          <Route path='koica' element={<KoicaHourly />} />
          <Route path='ravotxoji' element={<RavotxojiSahifa />} />
          <Route
            path='oqjarqizilqishloq'
            element={<OqjarqizilqishloqSahifa />}
          />
          <Route path='reykauchqurgon' element={<ReykauchqorgonSahifa />} />
          <Route path='vegetatsiya/*' element={<VegetatsiyaSahifa />} />
          <Route path='novegetatsiya/*' element={<NovegetatsiyaSahifa />} />
          <Route path='limit/*' element={<LimitSahifa />} />
          <Route path='sfr' element={<Sfr />} />
          <Route path='sfr/xisobot' element={<Xisobot />} />
        </Route>
        <Route path='*' element={<NotFound />} />
      </Routes>
    </Provider>
  );
}

export default Index;
